import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BaseComponent } from 'src/app/core/base/base.component';
import { AdminCatalogModel } from 'src/app/model/admin/catalog';
import { BaseModalModel } from 'src/app/model/core/base-modal';
import { SUBCATALOG_CONSTANTS } from './admin-subcatalog.constants';
import { AdminSubCatalogService } from './admin-subcatalog.service';

@Component({
  selector: 'ms-admin-subcatalog',
  templateUrl: './admin-subcatalog.component.html',
})
export class AdminSubCatalogComponent extends BaseComponent {
  readonly screen = SUBCATALOG_CONSTANTS;
  protected setScreen = true;
  catalogs: AdminCatalogModel[] = [];
  selectedCatalog: AdminCatalogModel = {};
  modal: BaseModalModel<AdminCatalogModel> = { value: {} };
  dtNameFilter?: string;
  options: MenuItem[] = [];
  isAdmin?: boolean;
  private subCatalogCode = '';

  constructor(
    protected service: AdminSubCatalogService,
    protected activatedRoute: ActivatedRoute
  ) {
    super();
  }

  onInit = () => {
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.subCatalogCode = paramMap.get('code') || 'NOT_VALID';
      this.service.setScreenInformation({
        id: this.subCatalogCode,
        title: `${this.screen.title}${this.subCatalogCode?.toUpperCase()}`,
      });
      this.subscriptions.push(
        this.service.getSubCatalogModal().subscribe(this.setModal),
        this.service
          .getSubCatalogStore(this.subCatalogCode)
          .subscribe(this.setSubCatalogStore),
        this.service.getUserInformation().subscribe((userInfo) => {
          if (userInfo.roles) {
            this.isAdmin = userInfo.roles.isAdmin;
          }
        })
      );
    });
    this.setDefaultContextMenu();
  };

  openModal = () => this.service.openModal();

  save = () => {
    this.service.setLoadingState();
    this.subscriptions.push(
      this.service.save(this.subCatalogCode, this.modal.value).subscribe()
    );
  };

  setContextMenuItems = () => {
    const idx = this.options.findIndex((op) => op.id === 'enableDisable');
    this.options[idx] = {
      ...this.options[idx],
      label:
        this.screen.actions[this.selectedCatalog.status ? 'disable' : 'enable'],
      styleClass: `text-${this.selectedCatalog.status ? 'danger' : 'success'}`,
      icon: `far ${
        this.selectedCatalog.status ? 'fa-trash-alt' : 'fa-check-circle'
      }`,
    };
  };

  private setDefaultContextMenu = () => {
    this.options.push({
      id: 'edit',
      label: this.screen.actions.edit,
      styleClass: 'text-warning',
      icon: 'fas fa-pencil-alt',
      command: () => this.service.openModal(this.selectedCatalog),
    });
    this.options.push({
      id: 'enableDisable',
      command: (_) =>
        this.subscriptions.push(
          this.service
            .patchStatus(this.subCatalogCode, this.selectedCatalog.id)
            .subscribe()
        ),
    });
  };

  private setSubCatalogStore = (store: AdminCatalogModel[]) => {
    if (!store || store.length === 0) {
      this.subscriptions.push(
        this.service
          .readSubCatalogs(this.subCatalogCode)
          .subscribe(this.setSubCatalogs)
      );
    } else {
      this.setSubCatalogs(store);
    }
  };

  private setSubCatalogs = (catalogs: AdminCatalogModel[]) =>
    (this.catalogs = catalogs);

  private setModal = (modal: BaseModalModel<AdminCatalogModel>) =>
    (this.modal = modal);
}
